import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { teamActions } from "@fitness-app/app-store";

import TraineeList from "~/modules/Trainee/TraineeList";
import TraineeWorkspace from "~/modules/Trainee/TraineeWorkspace/TraineeWorkspace";
import { useAppDispatch } from "~/store/initializeStore";

const TraineeRouter = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    void dispatch(teamActions.fetchTrainerConfig());
    void dispatch(teamActions.fetchAppVersionConfig());
  }, []);

  return (
    <Routes>
      <Route index element={<TraineeList />} />
      <Route path="/details/:id" element={<TraineeWorkspace />} />
      <Route path="/:tab/*" element={<TraineeList />} />
    </Routes>
  );
};

export default TraineeRouter;
